import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ComingSoon() {
    const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const raceDate = new Date("2026-05-17T00:00:00");
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const distance = raceDate - now;

            if (distance < 0) {
                clearInterval(interval);
                setCountdown({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setCountdown({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, [raceDate]);
    return (
        <div className="w-full min-h-screen relative">
            <div className="w-full bg-heroMobile md:bg-hero h-screen bg-no-repeat bg-cover bg-center text-[#164481]">
                <div className="container mx-auto w-full relative h-full md:px-24">
                    <div className="flex max-lg:flex-wrap items-center justify-center lg:items-center lg:justify-center gap-y-0 relative h-1/2 md:max-lg:top-1/4 lg:h-full max-md:top-1/4 lg:gap-x-36">
                        <div className="2xl:basis-2/3 md:px-0 px-6 max-lg:order-2 max-lg:basis-full flex flex-wrap max-lg:justify-center">
                            <div className="lg:basis-full rounded-lg">
                                <div className="font-bold">
                                    <div className="flex items-center justify-center text-center">
                                        <p className="text-8xl md:text-9xl text-brandYellow font-superWonder" style={{ letterSpacing: '3px' }}>COMING SOON</p>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute bottom-12 left-0 md:block hidden">
                                <p className="text-white font-poppins font-light">#BANDUNGBERCERITA</p>
                            </div>
                            <div className="relative justify-center md:hidden block top-12">
                                <p className="text-white font-poppins font-light">#BANDUNGBERCERITA</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
